import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const matchValidator = (referenceControlName: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const referenceControl = control.parent?.get(referenceControlName);
    return referenceControl && control && referenceControl.value !== control.value ? { mismatch: true } : null;
  };
};
